export default function ButtonMsg() {

    function klik() {

        const imie = prompt("Przedstaw sie ")
        if (imie) {
            localStorage.setItem("imie", imie);
            window.location.reload();
        }
    }

    const zapamietane = localStorage.getItem("imie");


    return (
        <div>
            {
                zapamietane ? (
                    <h2> Witaj ponownie {zapamietane} :) </h2>
                ) : (
                    <button onClick={klik}>Przedstaw sie </button>
                )
            }
        </div>
    )
}



